import type { BookingDetailsStore } from '../domain/types'
import { useStoreWithEqualityFn } from 'zustand/traditional'
import { useBookingDetailsDependencies } from './dependencies/dependencies'
import { bookingDetailsStore } from './store'

export function useBookingDetailsStore<T>(
  selector: (state: BookingDetailsStore) => T,
  equalityFn?: (a: T, b: T) => boolean,
): T {
  const { store = bookingDetailsStore } = useBookingDetailsDependencies()

  return useStoreWithEqualityFn(store, selector, equalityFn)
}
